import { Routes, Route } from "react-router";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Views
import EventsMain from 'Modules/events/views/main';

const RouterEvents = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "evnt") && <Route path="list" element={<EventsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterEvents;